import { Box, Group, Text, ThemeIcon, Title } from "@mantine/core";

interface Props {
  eyebrow?: string;
  title: string;
  /** Optional leading icon, rendered in a tinted ThemeIcon. */
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

/** Page/section structure: a small uppercase eyebrow over a Title order 5,
 *  with an optional leading icon and right-aligned action. */
export function SectionHeader({ eyebrow, title, icon, action }: Props) {
  return (
    <Group justify="space-between" align={icon ? "center" : "flex-end"} wrap="nowrap" gap="sm">
      <Group gap="sm" wrap="nowrap" align="center">
        {icon && (
          <ThemeIcon variant="light" color="brand" size={34} radius="md">
            {icon}
          </ThemeIcon>
        )}
        <Box>
          {eyebrow && (
            <Text size="xs" fw={600} c="dimmed" tt="uppercase" style={{ letterSpacing: "0.06em" }}>
              {eyebrow}
            </Text>
          )}
          <Title order={5}>{title}</Title>
        </Box>
      </Group>
      {action}
    </Group>
  );
}
